// @ts-strict-ignore
import { createPayloadAction } from '../../redux/helpers/redux-helpers'
import { FsCore } from '../../types/fs-core'

export interface SetProductTablePayload {
  id: string
  productTable: FsCore.ESProductTableState
}
export const setProductTable = createPayloadAction<SetProductTablePayload>('SET_PRODUCT_TABLE')
export interface UpdateProductTablePayload {
  id: string
  pageOffset: number
  selectedSort: FsCore.SortState
}
export const updateProductTable =
  createPayloadAction<UpdateProductTablePayload>('UPDATE_PRODUCT_TABLE')

export const setPageOffset = createPayloadAction<{ id: string; pageOffset: number }>(
  'SET_PAGE_OFFSET',
)
